/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdWebFeaturesFriendsSendFriendInviteNotificationRequest interface.
 */
export function instanceOfFxIdWebFeaturesFriendsSendFriendInviteNotificationRequest(value) {
    if (!('FriendAccountId' in value) || value['FriendAccountId'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesFriendsSendFriendInviteNotificationRequestFromJSON(json) {
    return FxIdWebFeaturesFriendsSendFriendInviteNotificationRequestFromJSONTyped(json, false);
}
export function FxIdWebFeaturesFriendsSendFriendInviteNotificationRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'FriendAccountId': json['FriendAccountId'],
    };
}
export function FxIdWebFeaturesFriendsSendFriendInviteNotificationRequestToJSON(json) {
    return FxIdWebFeaturesFriendsSendFriendInviteNotificationRequestToJSONTyped(json, false);
}
export function FxIdWebFeaturesFriendsSendFriendInviteNotificationRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'FriendAccountId': value['FriendAccountId'],
    };
}
//# sourceMappingURL=FxIdWebFeaturesFriendsSendFriendInviteNotificationRequest.js.map